// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandPrimary": `#512da8`,
	"brandPrimaryHover": `#7e57c2`,
	"brandSecondary": `#7e57c2`,
	"brandSuccess": `#457c3b`,
	"brandInfo": `#5bc0de`,
	"brandWarning": `#ed6c02`,
	"brandDanger": `#d9534f`,
	"bodyBg": `#222`,
	"baseTextColor": `#aec0d9`,
	"disabledTextColor": `#969696`,
	"defaultBorderColor": `rgba(19,19,20,.4392156863)`,
	"dividerBorderColor": `#424242`,
	"baseFont": `Roboto`,
	"fontSizeBase": `14px`,
	"borderRadius": `5px`,
	"buttonBorderRadius": `2px`,
	"buttonDefaultBackground": `#9e9e9e`,
	"buttonDefaultBackgroundHover": `#b3b2b2`,
	"buttonTextColor": `#fff`,
	"buttonFontSize": `13px`,
	"controlBorderColor": `rgba(218,218,218,.445)`,
	"controlHoverColor": `rgba(218,218,218,.199)`,
	"controlSelectionColor": `rgba(218,218,218,.096)`,
	"tableTheadBorderColor": `#393939`,
	"tableHeadBackground": `#000`,
	"switchTrackColor": `#a89bd1`,
	"chipSurfaceColor": `#50428e`,
	"chipBorderColor": `#5941c3`,
	"chipTextColor": `#fff`,
	"chipCloseColor": `hsla(0,0%,100%,.75)`
};
export default ___CSS_LOADER_EXPORT___;
